module.exports = __webpack_public_path__ + "img/acc12.1d0cda66.png";